var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#335EEA",
    opacity: 0.3,
    cx: 20.5,
    cy: 12.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#335EEA",
    opacity: 0.3,
    transform: "rotate(-15 12 6.5)",
    x: 3,
    y: 3,
    width: 18,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.337a3.5 3.5 0 1 0 0 6.326V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3.337z",
    fill: "#335EEA"
  }))));
};

export { SvgWallet as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48Y2lyY2xlIGZpbGw9IiMzMzVFRUEiIG9wYWNpdHk9Ii4zIiBjeD0iMjAuNSIgY3k9IjEyLjUiIHI9IjEuNSIvPjxyZWN0IGZpbGw9IiMzMzVFRUEiIG9wYWNpdHk9Ii4zIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTUgMTIgNi41KSIgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjciIHJ4PSIxIi8+PHBhdGggZD0iTTIyIDkuMzM3YTMuNSAzLjUgMCAxMDAgNi4zMjZWMThhMiAyIDAgMDEtMiAySDRhMiAyIDAgMDEtMi0yVjZhMiAyIDAgMDEyLTJoMTZhMiAyIDAgMDEyIDJ2My4zMzd6IiBmaWxsPSIjMzM1RUVBIi8+PC9nPjwvc3ZnPg==";